import React, {useCallback, useEffect} from 'react';
import PropTypes from 'prop-types';
import {Button, FormikEffect, FormikInput, Pricing, SimpleSelect} from "presentation/common/components";
import clsx from "clsx";
import {emptyFn} from "presentation/common/helpers/utils";
import CheckCircle from "presentation/common/components/style-guide/icons/CheckCircle";
import {Formik} from "formik";
import * as Yup from "yup";
import {isPlanBasic, isPlanFull} from "presentation/common";

import styles from './SelectPricingPlan.module.scss';

export const SelectPricingPlan = React.forwardRef((props, ref) => {
  const {initialValues, onUpdatePlanData, plansAvailable, licenseNumbersAvailable, isOtherBillUser} = props;

  const onPlanSelect = useCallback((planSelected) => {
    ref.current.setFieldValue('planSelected', planSelected);
    ref.current.setFieldValue('licenseNumber', '');
    ref.current.setFieldTouched('licenseNumber', false);
  }, [ref]);

  const handleVehicleTypeChange = useCallback((item) => {
    ref.current.setFieldValue('licenseNumber', item && item.id);
    ref.current.setFieldTouched('licenseNumber', true);
  }, [ref]);

  useEffect(() => {
    const {planSelected} = initialValues;
    if(isOtherBillUser && !isPlanBasic(planSelected)) {
      onPlanSelect(null);
    }
  }, [isOtherBillUser])

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={
        Yup.object().shape({
          planSelected: Yup.mixed().required('Es requerido que seleccione un plan.'),
          licenseNumber: Yup.number(),
        })
      }
      onSubmit={() => {
      }}>
      {
        (formik) => {
          const {
            values,
            handleSubmit,
            setFieldValue,
            validateForm,
            setFieldTouched,
            isValid,
            errors
          } = formik;

          ref.current = {validateForm, handleSubmit, isValid, values, errors, setFieldValue, setFieldTouched};
          const {planSelected} = values;

          return (
            <>
              <FormikEffect onChange={onUpdatePlanData}/>
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-2 xl:gap-4 mt-4 lg:mt-10">
                {
                  plansAvailable.map(plan => {
                    const disabled = (isOtherBillUser && !isPlanBasic(plan));
                    // const disabled = (isOtherBillUser && !isPlanBasic(plan)) || isPlanFull(plan);

                    return (
                      <Pricing
                        key={plan.id} {...plan}
                        className={clsx('mx-2 xl:mx-6', {'mt-4 lg:mt-0': plan.isBestSelling}, {[styles.planSelected]: planSelected && planSelected.id === plan.id})}>
                        <div className={styles.pickButtonContainer}>
                          {
                            planSelected && planSelected.id === plan.id
                              ?
                              <>
                                <CheckCircle className={styles.checkIcon} fontSize='large'/>
                                {
                                  planSelected.needLicenseNumber &&

                                  <FormikInput
                                    wrapperClassName="px-1"
                                    Component={SimpleSelect}
                                    name="licenseNumber"
                                    label="Terminación de Placa Patente"
                                    items={licenseNumbersAvailable}
                                    onChange={handleVehicleTypeChange}
                                  />
                                }
                              </>
                              : disabled
                                ? <p className="p-2 text-center text-primary font-semibold text-xl">Próximamente</p>
                                : <Button
                                  type="button"
                                  label={"Seleccionar" }
                                  className={clsx({[styles.isBestSelling]: plan.isBestSelling, [styles.disabled]: disabled})}
                                  onClick={() => onPlanSelect(plan)}/>
                          }
                        </div>
                      </Pricing>
                    );
                  })
                }
              </div>
            </>
          )
        }
      }
    </Formik>
  );
});

SelectPricingPlan.propTypes = {
  planSelected: PropTypes.object,
  onUpdatePlanData: PropTypes.func,
  plansAvailable: PropTypes.array,
  licenseNumbersAvailable: PropTypes.array,
  isOtherBillUser: PropTypes.bool
}

SelectPricingPlan.defaultProps = {
  onUpdatePlanData: emptyFn,
  initialValues: {planSelected: null},
  plansAvailable: [],
  licenseNumbersAvailable: [],
  isOtherBillUser: false
}

export default SelectPricingPlan;
